import {get} from './http';
import {type VideoStatusListResponse} from './videos';

export type ChannelStatus = {
  id: string;
  title: string | null;
  description: string | null;
  custom_url: string | null;
  thumbnail_url: string | null;
  published_at: string | null;
  country: string | null;
  privacy_status: string | null;
  is_linked: boolean | null;
  is_channel_monetization_enabled: boolean | null;
  made_for_kids: boolean | null;
  self_declared_made_for_kids: boolean | null;
  subscriber_count: number | null;
  video_count: number | null;
  view_count: number | null;
  // True when the channel hides its count, in which case subscriber_count arrives as 0 rather than
  // null - so a hidden count and a real zero are only distinguishable through this flag.
  hidden_subscriber_count: boolean | null;
  // The channel's own targeting terms, comma-joined by the API layer (the platform returns them
  // space-separated with quoted phrases).
  keywords: string | null;
  // Readable names, not the Wikipedia URLs the platform returns.
  topic_categories: string[] | null;
  banner_url: string | null;
};

export type ChannelStatusListResponse = {
  results: ChannelStatus[];
};

export const channelsApi = {
  status: async (ids: string[]) =>
    get<ChannelStatusListResponse>('/channels/status', {ids: ids.join(',')}),

  byHandle: async (handle: string) =>
    get<ChannelStatus>(`/channels/by-handle/${encodeURIComponent(handle)}`),

  forVideo: async (videoId: string) =>
    get<ChannelStatus>(`/channels/for-video/${encodeURIComponent(videoId)}`),

  // Newest-first uploads. Empty for anything that isn't a UC… channel id.
  latestVideos: async (channelId: string, max = 12) =>
    get<VideoStatusListResponse>(`/channels/${encodeURIComponent(channelId)}/videos`, {max})
};
